import { Controller } from "@hotwired/stimulus"
import debounce from "debounce";

// Connects to data-controller="bd-libraire-form"
// Turbo Drive is OFF (app/javascript/packs/admin.js:20), so nothing refreshes
// the live preview automatically. On any change/input inside the form, reload
// the "bd_libraire_preview" Turbo Frame with the current (unsaved) field
// values via its `src` — the server renders the real customer-facing
// partials from those params (see rails-hotwire's arch-avoid-client-state:
// no HTML is ever built here, only a URL).
export default class extends Controller {
  static targets = ["form", "openEndedWarning", "bioWarning"]
  static values = { previewUrl: String }

  initialize() {
    this.refresh = debounce(this.refresh.bind(this), 300);
  }

  refresh() {
    this.toggleWarnings();

    const frame = document.getElementById("bd_libraire_preview");
    if (!frame) return;

    // File entries cannot travel on a GET — URLSearchParams would serialise
    // them as "[object File]" and the preview would silently fall back to the
    // stored image. The bd-libraire-picture controller has already cached any
    // pending upload into the matching `_cache` field, which does travel.
    const params = new URLSearchParams();
    new FormData(this.formTarget).forEach((value, key) => {
      if (value instanceof File) return;
      params.append(key, value);
    });

    frame.src = this.previewUrlValue + "?" + params.toString();
  }

  // Ephemeral show/hide only — the warning copy itself is server-rendered
  // (see show.html.erb), Stimulus just toggles which state is visible.
  toggleWarnings() {
    const data = new FormData(this.formTarget);

    if (this.hasOpenEndedWarningTarget) {
      const openEnded = data.get("bd_libraire_form[open_ended]") === "true";
      this.openEndedWarningTarget.style.display = openEnded ? "block" : "none";
    }

    if (this.hasBioWarningTarget) {
      const bio = (data.get("bd_libraire_form[bd_landing_bio]") || "").trim();
      this.bioWarningTarget.style.display = bio ? "none" : "block";
    }
  }
}
